import XHR, { DEBUG } from '@/api'
import Md5 from 'js-md5'
import { Encrypt } from '../plugins/utils.js'
export default {
  data: () => ({
    deviceType: '',
    imgUrl: `https://s${DEBUG ? '-test' : ''}.kcimg.cn`
  }),
  created () {
    this.deviceType = this.checkPlatform()
  },
  computed: {
    // 定位城市
    locationProvince () {
      return this.$store.state.locationProvince
    },
    // 定位省份
    locationCity () {
      return this.$store.state.locationCity
    }
  },
  methods: {
    // md5加密
    encryptionJson (json) {
      const encryption = 'uateP9a4jm7okKCw'
      const newObj = {}
      json.timestamp = JSON.stringify(Date.parse(new Date()) / 1000)
      const arg = Encrypt(json)
      const keyArraySort = Object.keys(json).sort()
      for (var i = 0; i < keyArraySort.length; i++) {
        const k = keyArraySort[i]
        newObj[k] = json[k]
      }
      const data = Md5(`${JSON.stringify(newObj)}${encryption}`)
      const obj = {
        arg: arg,
        token: data,
        timestamp: json.timestamp
      }
      return obj
    },
    // 判断是什么端
    checkPlatform: function checkplatform () {
      var uaCase = navigator.userAgent.toLowerCase()
      if (uaCase.indexOf('micromessenger') >= 0) {
        return 'weixin'
      } else if (uaCase.indexOf('360che') >= 0) {
        return 'app'
      } else if (
        /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(
          navigator.userAgent
        )
      ) {
        return 'm'
      } else {
        return 'pc'
      }
    },
    // ios微信失去焦点问题
    onBlur () {
      const timer = setTimeout(() => {
        const scrollHeight =
            document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
        timer && clearTimeout(timer)
      }, 100)
    },
    showErrorInfo (msg) {
      if (this.deviceType !== 'app') {
        this.$toast({
          message: msg,
          type: 'info',
          duration: 2000
        })
      } else {
        window.callNativeMethod('onToast', {
          message: msg
        })
      }
    },
    // 改变标题
    changeTitle (title) {
      if (this.deviceType === 'app') {
        window.callNativeMethod('onChangeWebTitle', {
          changeWebTitle: title
        })
      } else {
        document.title = title
      }
    },
    // 进入个人中心
    enterPerson (uid) {
      if (this.deviceType === 'app') {
        window.callNativeMethod('onPersonCenter', {
          uid: uid
        })
      }
    },
    sendAnalytics (c, a, l) {
      setTimeout(() => {
        try {
          // eslint-disable-next-line
          ga('send', 'event', c, a, l)
        } catch (e) {}
      }, 0)
    },
    sendTruckhomeEvent (c, a, l) {
      try {
        // eslint-disable-next-line
        Truckhome_eventFun(c, a, l)
      } catch (e) {
        console.log(e)
      }
    },
    checkLeftTime (leftSec) {
      const hours = parseInt(leftSec / 3600) // 小时
      const minutes = parseInt((leftSec - hours * 3600) / 60) // 分钟
      const seconds = parseInt(leftSec - hours * 3600 - minutes * 60) // 秒
      return [this.supplementZero(hours), this.supplementZero(minutes), this.supplementZero(seconds)]
      // return `${this.supplementZero(hours)}:${this.supplementZero(minutes)}:${this.supplementZero(seconds)}`
    },
    // 数字不足两位补0
    supplementZero (data) {
      data = data + ''
      return data.length === 1 ? '0' + data : data
    },
    // app分享
    appShareBtn (shareObj) {
      if (this.deviceType === 'app') {
        window.callNativeMethod('onShowShareButton', {
          isShow: true,
          title: shareObj.title, // 分享标题
          desc: shareObj.desc, // 分享描述
          link: shareObj.link, // 分享链接
          imgUrl: shareObj.imgUrl // 分享图标
        })
      }
    },
    // 微信方法初始化
    wxConfig () {
      if (this.deviceType === 'weixin') {
        XHR.getWeixin({ url: window.location.href.split('#')[0] }).then((res) => {
          const { data, status } = res.data
          if (!status) {
            window.wx.config({
              debug: false,
              appId: data.appId,
              timestamp: data.timestamp,
              nonceStr: data.nonceStr,
              signature: data.signature,
              jsApiList: [
                'updateTimelineShareData',
                'updateAppMessageShareData',
                'hideMenuItems'
              ]
            })
          }
        }).catch(error => {
          console.log(error)
          if (
            error.request &&
            error.request.readyState === 4 &&
            error.request.status === 0
          ) {
            this.wxConfig()
          }
        })
      }
    },
    // 定义分享文案
    wxSharePage (shareObj) { // 微信分享等方法
      if (this.deviceType === 'weixin') {
        window.wx.ready(() => {
          let shareLink = location.href
          // 获取cookie 加微信埋点
          const udstatistics = document.cookie.match(/udstatistics=([^;$]+)/)
          const hrefWxId = location.href.match(/wxzfr=([^&$]+)/)
          if (udstatistics && udstatistics[1]) {
            if (hrefWxId && hrefWxId[1]) {
              shareLink = shareLink.replace(hrefWxId[1], `wx_${udstatistics[1]}`)
            } else {
              shareLink = shareLink + '&wxzfr=wx_' + udstatistics[1]
            }
          }
          console.log(shareLink)
          const udstatisticss = document.cookie.match(/udstatisticss=([^;$]+)/)
          if (udstatisticss && udstatisticss[1]) {
            shareLink = shareLink + '&wxzfr_vid=wx_' + udstatisticss[1]
          }
          window.wx.hideMenuItems({
            menuList: [
              'menuItem:editTag',
              'menuItem:delete',
              'menuItem:copyUrl',
              'menuItem:share:qq',
              'menuItem:share:QZone',
              'menuItem:openWithQQBrowser',
              'menuItem:openWithSafari',
              'menuItem:share:email',
              'menuItem:share:weiboApp']
          })
          window.wx.updateTimelineShareData({
            title: shareObj.title,
            link: shareLink,
            imgUrl: shareObj.imgUrl || 'https://s.kcimg.cn/app/quick/images/app-logo.png',
            success: () => {
              try {
                // eslint-disable-next-line
                Truckhome_eventFun('ck_share', '', '')
              } catch (e) {
              }
            },
            cancel: () => {
              // console.log('分享失败')
            }
          })
          // 分享给朋友
          window.wx.updateAppMessageShareData({
            title: shareObj.title,
            desc: shareObj.desc || '',
            link: shareLink,
            imgUrl: shareObj.imgUrl || 'https://s.kcimg.cn/app/quick/images/app-logo.png',
            success: () => {
              try {
                // eslint-disable-next-line
                Truckhome_eventFun('ck_share', '', '')
              } catch (e) {
              }
            },
            cancel: function () {
              // console.log('分享失败')
            }
          })
        })
      }
    },
    // 只能输入中文，数字，英文
    checkName (val) {
      return val.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]/g, '')
    },
    clearEmoji (val) {
      return val.replace(/[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g, '')
    },
    // 判断手机号格式是否正确
    isPhoneNumber (tel) {
      const reg = /^(13[0-9]|14[578]|15[0-3,5-9]|16[567]|17[01235678]|18[0-9]|19[189])\d{8}$/
      return reg.test(tel)
    },
    // 复制到剪切板
    copy (copytxt) {
      // console.log(window.navigator.clipboard)
      if (!window.navigator.clipboard) {
        this.fitCopy(copytxt)
        return
      }
      window.navigator.clipboard
        .writeText(copytxt)
        .then(() => {
        })
        .catch(() => {
          this.fitCopy(copytxt)
        })
    },
    fitCopy (copytxt) {
      const input = document.createElement('input')
      input.style = 'position: fixed;top: -100px;'
      document.body.appendChild(input)
      input.setAttribute('value', copytxt)
      input.select()
      if (document.execCommand('copy')) {
        document.execCommand('copy')
      }
      document.body.removeChild(input)
    },
    jumpOuterPage ({ fullPath = '', path = '' }) {
      if (fullPath) {
        console.log(fullPath, '订单')
        window.location.href = fullPath
      }
    },
    libExample (type, id) {
      const protocol = 'truckhomefuse'
      const UA = navigator.userAgent
      const option = {
        scheme: {
          protocol
        },
        wxAppid: 'wx3cc08b56b3f3077c',
        appstore:
          'https://apps.apple.com/app/apple-store/id653300680?pt=986281&ct=MDiversion&mt=8',
        yingyongbao:
          'https://a.app.qq.com/o/simple.jsp?pkgname=com.truckhome.bbs',
        fallback: 'https://download.360che.com/quickapp/share-guide.html',
        timeout: 200
      }
      // ios端
      if (/(iPhone|iPad|iPod|iOS)/i.test(UA)) {
        option.universal = {
          host: 'app.360che.com'
        }
      }
      // eslint-disable-next-line no-undef
      return new CallApp(option)
    },
    // 配置可拉起app按钮
    wxPullApp (lib, type, id) {
      const config = {
        path: '360chefuse.com',
        param: {
          type,
          id
        },
        callback: () => {
          if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            const universalLink = `truckhomefuse://360chefuse.com?type=${type}&id=${id}`
            this.copy(universalLink)
          }
        }
      }
      lib.open(config)
    }
  }
}
